import { FilterClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { LinkUtils } from '@atlassian/mpac-utils';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import { shouldFacetBeShown } from "../../../../../../common/utils/filters";
import { ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER, EVENT_CHANNEL, EVENT_SOURCE, OBJECT_TYPE_FILTER } from "../../../../../constants/analytics/events";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import Facet from "./Facet";
export default function Facets(props) {
  const facets = props.facets.filter(f => shouldFacetBeShown(f.get('key'), props.hiddenFilters));
  const forceFacetsExpanded = facets.size <= 2;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onFacetProductClick = (event, _ref) => {
    let {
      facetKey,
      facetValue,
      selected,
      newPerspective,
      newFilters,
      selectedContent
    } = _ref;
    fireAnalyticsEvent({
      eventType: FilterClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER,
      objectType: OBJECT_TYPE_FILTER,
      objectId: facetKey,
      source: EVENT_SOURCE,
      label: selectedContent,
      attributes: {
        currentPerspective: props.perspective,
        filterValue: facetValue,
        selected: !selected
      }
    }, EVENT_CHANNEL);
    LinkUtils.maybeOpenInNewTab(event, () => {
      props.stateChangeRequested({
        perspective: newPerspective,
        filters: newFilters
      });
    });
  };
  return /*#__PURE__*/React.createElement("div", null, facets.map(facet => {
    return /*#__PURE__*/React.createElement(Facet, {
      itemFactory: props.itemFactory,
      forceExpanded: forceFacetsExpanded,
      facet: facet,
      filters: props.filters,
      filtersContext: props.filtersContext,
      filtersLink: props.filtersLink,
      hiddenFilters: props.hiddenFilters,
      key: "facet-".concat(facet.get('key')),
      onFacetProductClick: onFacetProductClick,
      perspective: props.perspective,
      stateChangeRequested: props.stateChangeRequested
    });
  }));
}
Facets.propTypes = {
  facets: ImmutablePropTypes.list.isRequired,
  filters: CommonPropTypes.filters,
  filtersContext: AddonDiscoveryPropTypes.filtersContext,
  filtersLink: PropTypes.func.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  stateChangeRequested: PropTypes.func.isRequired
};